var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3"},[_c('h3',[_vm._v("Integrasi BCA")]),_c('v-card',{staticClass:"mt-6 pa-3 d-flex justify-center align-center",attrs:{"outlined":"","height":"400px"}},[_vm._v(" Coming Soon 🚀 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }